<template>
  <div id="content-page" class="content-page">
    <div class="iq-top-navbar">
      <div class="iq-navbar-custom">
        <nav class="navbar navbar-expand-lg navbar-light p-0">
          <router-link :to="homeURL">
            <img v-if="defaultAvatarLogo" :src="fileLogo" class="top-logo" />
            <img v-else class="top-logo" v-bind:src="'data:image/jpeg;base64,' + fileLogo" />
          </router-link>
        </nav>
      </div>
    </div>
    <b-container fluid>
      <b-row>
        <b-col>
          <iq-card>
            <template v-slot:headerTitle class="w--100">
              <h4 class="card-title float-left title-typography-color">
                <i class="fas fa-file"></i>
                {{ $t("public.views.Pages.Petitioner.title") }}
              </h4>
              <div class="text-right w-100">
                <a v-if="file" :download="file.name" :href="'data:application/octet-stream;base64,' + file.data">
                  <b-button style="right" variant="success">{{
                    $t("public.views.Pages.Petitioner.btnDownload")
                  }}
                  </b-button>
                </a>
              </div>
            </template>
            <template v-slot:body>
              <div class="about-info m-0 p-0">
                <div class="row">
                  <div class="col-12">
                    <h6>
                      <div>
                        {{ $t("public.views.Pages.Petitioner.professional") }}:
                      </div>
                    </h6>
                  </div>
                  <div class="col-12">
                    {{
                      petitioner.professional.name +
                        " " +
                        petitioner.professional.lastname +
                        " (" +
                        petitioner.professional.document +
                        ") "
                    }}
                  </div>
                  <div v-if="petitioner.professional.speciality">
                    <div class="col-12">
                      <h6>
                        <div>
                          {{
                            $t(
                                                    "public.views.Pages.Petitioner.professionalSpeciality"
                            )
                          }}:
                        </div>
                      </h6>
                    </div>
                    <div class="col-12">
                      {{ petitioner.professional.speciality.name }}
                    </div>
                  </div>
                  <div class="col-12">
                    <h6>
                      <div>
                        {{
                          $t(
                                                "public.views.Pages.Petitioner.professionalMemberId"
                          )
                        }}:
                      </div>
                    </h6>
                  </div>
                  <div class="col-12">
                    {{ petitioner.professional.memberId }}
                  </div>
                  <div class="col-12">
                    <h6>
                      <div>
                        {{
                          $t("public.views.Pages.Petitioner.professionalPhone")
                        }}:
                      </div>
                    </h6>
                  </div>
                  <div class="col-12">{{ petitioner.professional.phone }}</div>
                  <div class="col-12">
                    <h6>
                      <div>
                        {{ $t("public.views.Pages.Petitioner.patient") }}:
                      </div>
                    </h6>
                  </div>
                  <div class="col-12">
                    {{
                      petitioner.patient.name +
                        " " +
                        petitioner.patient.lastname +
                        " (" +
                        petitioner.patient.document +
                        ") "
                    }}
                  </div>

                  <div class="col-12">
                    <h6>
                      <div>
                        {{
                          $t("public.views.Pages.Petitioner.patientDocument")
                        }}:
                      </div>
                    </h6>
                  </div>
                  <div class="col-12">{{ petitioner.patient.document }}</div>
                  <div class="col-12">
                    <h6>
                      <div>
                        {{ $t("public.views.Pages.Petitioner.patientMutua") }}:
                      </div>
                    </h6>
                  </div>
                  <div class="col-12">{{ petitioner.patient.mutual }}</div>
                  <div class="col-12">
                    <h6>
                      <div>
                        {{ $t("public.views.Pages.Petitioner.petitioner") }}:
                      </div>
                    </h6>
                  </div>
                  <div class="col-12">{{ petitioner.petitioner }}</div>
                  <div class="col-12">
                    <h6>
                      <div>
                        {{
                          $t("public.views.Pages.Petitioner.dispensationDate")
                        }}:
                      </div>
                    </h6>
                  </div>
                  <div class="col-12">{{ petitioner.dispensationDate }}</div>
                </div>
              </div>
            </template>
          </iq-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import petitionerService from "../../services/petitioner";
import organizationService from "../../services/organization";
import utilsService from "../../services/utils";

export default {
  name: "PetitionerPublic",
  mounted() {
    this.getLogoOrganization();
    this.getPdfByToken();
    this.getByToken();
  },
  data() {
    return {
      homeURL: {
        type: Object,
        default: () => ({ name: "public.singin" }),
      },
      file: "",
      defaultAvatarLogo: true,
      fileLogo: "",
      petitioner: {},
    };
  },
  methods: {
    async getByToken() {
      let self = this;

      this.$awn.asyncBlock(
        petitionerService.getByToken(this.$route.query.token),
        (response) => {
          if (response) {
            self.petitioner = response.data;
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "petitionerService.getByToken",
            module: "view-pages-petitioner",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              userId: localStorage.getItem("userId")
            })
          });
        },
        " "
      );
    },
    async getPdfByToken() {
      let self = this;

      this.$awn.asyncBlock(
        petitionerService.getPdfByToken(this.$route.query.token),
        (response) => {
          if (response) {
            self.file = response.data;
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "petitionerService.getPdfByToken",
            module: "view-pages-petitioner",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              userId: localStorage.getItem("userId")
            })
          });
        },
        " "
      );
    },
    async getLogoOrganization() {
      let self = this;

      this.$awn.asyncBlock(
        organizationService.findLogo(this.$route.query.organization),
        (response) => {
          if (response) {
            self.getLogo(response.data);
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "organizationService.findLogo",
            module: "view-pages-petitioner",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              userId: localStorage.getItem("userId")
            })
          });
        }
      );
    },
    getLogo(uuid) {
      let self = this;
      utilsService
        .getFile(uuid)
        .then((response) => {
          if (response) {
            self.defaultAvatarLogo = false;
            self.fileLogo = response.data.data;
          } else {
            self.defaultAvatarLogo = true;
            self.fileLogo = require("../../assets/images/logo.png");
          }
        })
        .catch(function (error) {
          self.defaultAvatarLogo = true;
          self.fileLogo = require("../../assets/images/logo.png");
        });
    },
  },
};
</script>
